import useLockedPromotions from 'bento-ordering/promotions/hooks/useLockedPromotions';
import { QUALIFYING_ITEMS } from 'constants/promotions';

/**
 * The logic for the this function is based on if both promotions have qualifying items,
 * return the promotions with least quantity until bogo unlocked but if only 1 promotion
 * has qualifying items, we have to calculate the quantity until bogo unlocked vs the amount
 * before unlocked and return the lowest value. If amount before unlocked is less than or
 * equal to the quantity until bogo unlocked, we return the amount before unlocked promo, as
 * $1 left to unlock should be a lesser value than purchase 1 more item to unlock.
 */
function useClosestPromotionToUnlock() {
  const lockedPromotions = useLockedPromotions();
  if (!lockedPromotions.length) {
    return null;
  }
  const lowestPromoAmountBeforeUnlocked = lockedPromotions
    .map(promotion => {
      return {
        compareField:
          promotion.promotion.minimum_purchase_requirement === QUALIFYING_ITEMS
            ? promotion.quantity_until_bogo_unlocked
            : promotion.amount_before_unlocked,
        ...promotion
      };
    })
    .reduce((acc, curr) => {
      if (acc && acc.compareField === curr.compareField) {
        return acc.promotion.minimum_purchase_requirement === QUALIFYING_ITEMS
          ? curr
          : acc;
      } else if (acc && acc.compareField < curr.compareField) {
        return acc;
      }
      return curr;
    }, null);

  const {
    compareField,
    ...closestPromotionToUnlock
  } = lowestPromoAmountBeforeUnlocked;
  return { ...closestPromotionToUnlock };
}

export default useClosestPromotionToUnlock;
